import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useAuth } from '../auth/AuthAllapot.tsx';
import { supabase } from '../lib/supabase.ts';
import { HIVAS_EREDMENY_CIMKE } from '../lib/tipusok.ts';
import { Gomb, HibaUzenet } from '../ui/elemek.tsx';

export default function HivasGombok({ leadId, officeId }: { leadId: string; officeId: string }) {
  const { session } = useAuth();
  const qc = useQueryClient();
  // A hívás nem kapcsoló (többször is rögzíthető), ezért csak a legutóbb itt rögzítettet jelöljük vissza.
  const [utolso, setUtolso] = useState<{ leadId: string; eredmeny: string; ido: Date } | null>(null);
  const rogzitett = utolso?.leadId === leadId ? utolso : null;
  const mentes = useMutation({
    mutationFn: async (eredmeny: string) => {
      const { error } = await supabase.from('lead_esemenyek').insert({
        lead_id: leadId, office_id: officeId, tipus: 'hivas', adat: { eredmeny }, szerzo: session?.user.id ?? null,
      });
      // A státuszt szándékosan nem állítjuk: az automatikus „Elérve” miatt maradtak lezáratlanul a leadek
      // (2026-10-29), a státuszt a kolléga a Státusz kártyán maga választja ki.
      if (error) throw error;
    },
    onSuccess: (_, eredmeny) => setUtolso({ leadId, eredmeny, ido: new Date() }),
    onSettled: async () => {
      await Promise.all([
        qc.invalidateQueries({ queryKey: ['lead', leadId] }),
        qc.invalidateQueries({ queryKey: ['esemenyek', leadId] }),
        qc.invalidateQueries({ queryKey: ['leadek'] }),
      ]);
    },
  });
  return (
    <div className="grid gap-2">
      <p className="text-sm font-medium text-szoveg-halk">Hívás eredménye</p>
      <div className="grid gap-2 sm:grid-cols-3">
        {Object.entries(HIVAS_EREDMENY_CIMKE).map(([kulcs, cimke]) => {
          const ez = rogzitett?.eredmeny === kulcs;
          return (
            <Gomb
              key={kulcs}
              valtozat={ez ? 'halvany' : 'masodlagos'}
              className={ez ? 'ring-1 ring-kiemelt' : ''}
              toltes={mentes.isPending && mentes.variables === kulcs}
              disabled={mentes.isPending}
              onClick={() => mentes.mutate(kulcs)}
            >
              {ez && <span aria-hidden>✓</span>}
              {cimke}
            </Gomb>
          );
        })}
      </div>
      <p role="status" className="min-h-5 text-sm text-kiemelt">
        {rogzitett && `Rögzítve ${rogzitett.ido.toLocaleTimeString('hu-HU', { hour: '2-digit', minute: '2-digit' })}-kor: ${HIVAS_EREDMENY_CIMKE[rogzitett.eredmeny]}. Az idővonalon is látszik.`}
      </p>
      <HibaUzenet hiba={mentes.error} />
    </div>
  );
}
